'use client'

import { useAuth } from '@/providers/AuthContext'
import { evaluatePermission, type PermissionExpr } from '@/lib/permissions/check'
import type { AuthUser } from '@/types/auth'

export interface UsePermissionsResult {
  isLoading: boolean
  /** Snapshot ainda não confirmado pelo primeiro `/auth/me` — ver `AuthContext`. */
  isRevalidating: boolean
  user: AuthUser | null
  role: string | null
  permissions: string[]
  hasPermission: (expr: PermissionExpr) => boolean
}

export function usePermissions(): UsePermissionsResult {
  const { user, isLoading, isRevalidating } = useAuth()
  return {
    isLoading,
    // `?? false`: a maioria dos testes mocka `useAuth` sem o campo — ausente = assentado.
    isRevalidating: isRevalidating ?? false,
    user,
    role: user?.role ?? null,
    permissions: user?.permissions ?? [],
    hasPermission: (expr) =>
      user ? evaluatePermission(expr, { role: user.role, permissions: user.permissions }) : false,
  }
}

export function useHasPermission(expr: PermissionExpr): boolean {
  return usePermissions().hasPermission(expr)
}
